import {Component} from "../../../../../../../sedestral/framework/interface/component/Component";
import {WebsiteBlackUnionLineComponent} from "../../union/line/WebsiteBlackUnionLineComponent";
import * as s from "./website-black-cases-flow.scss";
import {WebsiteBlackCasesComponent} from "../WebsiteBlackCasesComponent";
import {IWebsiteBlackCasesFlow} from "./types/IWebsiteBlackCasesFlow";

export class WebsiteBlackCasesFlowComponent extends Component {
    constructor(flow: IWebsiteBlackCasesFlow) {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackCasesFlow}">
                <div class="${s.union}">
                    ${this.draw(new WebsiteBlackUnionLineComponent("green"))}
                </div>
                <div class="${s.description}">
                    ${flow.description}
                </div>
                ${this.draw(new WebsiteBlackCasesComponent(flow.cases))}
            </div>
        `;
    }
}